import { useMutation, useQuery } from '@tanstack/react-query';
import { getConstructionFee, saveConstructionFee } from 'app/edozvola/cases/construction-fee/service/construction-fee.service';
import { showToast } from 'app/shared/util/toast.util';
import { ConstructionFeeModel } from 'app/edozvola/cases/construction-fee/model/construction-fee.model';
import { toast } from 'react-toastify';
import success = toast.success;
import error = toast.error;
import {messages} from "app/config/constants";

export const fetchConstructionFeeQuery = (caseUuid: string) => {
  return useQuery({
    queryKey: ['construction-fee', caseUuid],
    queryFn: () => getConstructionFee(caseUuid),
    enabled: !!caseUuid,
  });
};

export const saveConstructionFeeQuery = (caseUuid: string, resetFunction) => {
  return useMutation({
    mutationFn: (constructionFee: ConstructionFeeModel) => {
      return saveConstructionFee(caseUuid, constructionFee);
    },
    onSuccess: (data, variables) => {
      showToast(success, messages.DATA_SAVED);
      resetFunction({values: variables})
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};
